import { Component, Injectable, OnInit } from '@angular/core';

import { PointsService } from 'src/app/services/points.service';
import { PerformanceReportService } from 'src/app/services/performance-report-service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { RunPlanningDTO, SegmentDTO } from 'src/app/models/performanceReportDTO';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { TabsService } from 'src/app/services/tabsService';


@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-performance-report',
  templateUrl: './performance-report.component.html',
  styleUrls: ['./performance-report.component.scss'],
  standalone: false

})
export class PerformanceReportComponent implements OnInit {
  private checkedPathIndex: number = null;
  constructor(
    public performanceService: PerformanceReportService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public pointsService: PointsService,
    public configurationService: ConfigurationService,
    public tabsService: TabsService
     ) {

   }

  ngOnInit(): void {
  }
  public getNavaids(){
    if(!this.performanceService.active){
      return ;
    }
    return this.performanceService.report.navaidsTable
  }
  public changePaths(event,index:number,field:string){
    this.performanceService.paths[index].runplanning[field] = event.target.value;
  }
  public checkPath(index){
    if(index == this.checkedPathIndex){
      this.performanceService.paths[index].checked = false; //unchecking
      this.checkedPathIndex = null
      return
    }
    this.performanceService.paths[index].checked = true;
    if(this.checkedPathIndex != null){
      this.performanceService.paths[this.checkedPathIndex].checked = false // unchecking previous
    }
    this.checkedPathIndex = index;
  }

  public moveChecked(value){
    if((this.checkedPathIndex == null) || (this.checkedPathIndex == 0 && value == "up") || (this.checkedPathIndex == this.performanceService.paths.length - 1 && value == "down") ){
      return;
    }
    let new_index = this.checkedPathIndex + (value == "up"? -1 : 1)
    let aux = this.performanceService.paths[this.checkedPathIndex];
    this.performanceService.paths[this.checkedPathIndex] = this.performanceService.paths[new_index];
    this.performanceService.paths[new_index] = aux;
    this.checkedPathIndex = new_index;
  }
  public removePaths(){
    this.performanceService.paths = this.performanceService.paths.filter((path) => !path.checked);
    this.checkedPathIndex = null
  }
  public addPath(){
    let path = new HTMLPath();
    path.runplanning = new RunPlanningDTO();
    path.runplanning.pathSpec = "fullForward";
    path.checked = false;
    this.performanceService.paths.push(path);
  }
  public getDMEField(i:number){
    return 'dme'+i;
  }
  public getProcedureTable(){
    if(!this.performanceService.active){
      console.log();
      return ;
    }
    return this.performanceService.report.procedureTable;
  }
  public getPerformanceTable(){
    if(!this.performanceService.active){
      console.log();
      return ;
    }
    return this.performanceService.report.performanceTable
  }

  public wayPointInfoTable(){
    if(!this.performanceService.active){
      console.log();
      return ;
    }
    return this.performanceService.report.wayPointsInfoTable;
  }

  cancelPerformanceAnalysis():void{
    this.performanceService.closeWindow();


  }
  changePath(i,value){
    this.performanceService.paths[i].runplanning.notes = value
  }
}
export class HTMLPath{
  checked: boolean;
  runplanning: RunPlanningDTO;

}
